import { configure } from 'mobx';
import { createRoot } from 'react-dom/client';
import { BugsnagEventLogger, EventLogger } from '../models/Logging';
import { SonnerToast } from '../web/components/SonnerToast';
import { LevReactQueryDevtools } from '../web/ReactQueryDevtools';
import { ReactQueryProvider } from '../web/ReactQueryProvider';
import CustomerAssistantRouter from './CustomerAssistantRouter';
import './main.less';

const bugsnagEventLogger = new BugsnagEventLogger(import.meta.env.MODE);
const ErrorBoundary = bugsnagEventLogger.getErrorBoundary();
EventLogger.addLogger(bugsnagEventLogger);

document.addEventListener('DOMContentLoaded', async () => {
	configure({ enforceActions: 'never' });

	const root = createRoot(document.getElementById('react-root'));
	root.render(
		<ErrorBoundary>
			<ReactQueryProvider>
				<CustomerAssistantRouter />
				<SonnerToast />
				<LevReactQueryDevtools />
			</ReactQueryProvider>
		</ErrorBoundary>
	);
});
